@use "@fukuri-admins/ui/layout" as *;

.form {
  max-width: 564px;
}

.title {
  color: text("High");
  @include typography("Jp/20_W6");
}

.actions {
  padding-top: spacing("16");
}

.selectOption {
  display: flex;
  @include typography("Jp/14_W3");

  &__name {
    color: text("High");
  }

  &__code {
    color: text("Low");
  }
}
